import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const PageContentContainerStyles = makeStyles((theme: Theme) => ({
    pageContents: {}
}));
